import { render, staticRenderFns } from "./BaseBForm.vue?vue&type=template&id=9f3b7ea8&scoped=true"
import script from "./BaseBForm.vue?vue&type=script&lang=js"
export * from "./BaseBForm.vue?vue&type=script&lang=js"
import style0 from "./BaseBForm.vue?vue&type=style&index=0&id=9f3b7ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3b7ea8",
  null
  
)

export default component.exports